/**
 * Add / delete a decoder for a user.
 */
export const decoderOperation = async (operation, userId, decoderId) => {
  const response = await fetch(`/api/user/decoders`, {
    method: operation,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_id: userId, decoder_id: decoderId }),
  });
  if (!response.ok) throw new Error("Decoder operation failed");
  return await response.json();
};

